import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.tsx";
import "./index.css";

const goc = document.getElementById("root");
if (!goc) throw new Error("Khong tim thay #root trong index.html");

createRoot(goc).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
